import { customElement } from "lit/decorators.js";
import { FeaturedIcon } from "@/components/featured-icon";

@customElement("eko-modal-icon")
class ModalIcon extends FeaturedIcon {
  constructor() {
    super();

    this.size = "lg";
    this.variant = "square-modern";
    // this.theme = "danger";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-modal-icon": ModalIcon;
  }
}

export default ModalIcon;
